/***********************
 * ALERT TYPES
 ************************/

const allAlerts = {
  activity: {
    title: "Activity",
    key: "Activity",
    ids: [6, 12, 14, 16, 24, 25],
  },
  ab: { title: "Abnormal activity", key: "AB", ids: [17, 15, 13] },
  health: { title: "Health", key: "Health", ids: [30, 27, 28, 31] },
  devices: {
    title: "Devices",
    key: "Devices",
    ids: [1, 2, 10, 11, 26, 29, 32, 33, 44, 45, 46, 47, 48, 51, 52, 53],
  },
  safety: { title: "Safety", key: "Safety", ids: [3, 4, 35, 36, 42, 5] },
  apartment: {
    title: "Apartment",
    key: "Apartment",
    ids: [20, 21, 22, 23, 37, 38, 18, 19],
  },
  other: { title: "Other", key: "Other", ids: [34, 39, 43] },
}

export { allAlerts }
